import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import axios from "axios";
import store from "./store";
const { config } = require("../public/serverConfig");
import "babel-polyfill";
import Es6Promise from "es6-promise";
Es6Promise.polyfill();

import dataV from "@jiaminghi/data-view";
Vue.use(dataV);

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import 'videojs-contrib-hls';
import "video.js/dist/video-js.css";

// Vue.prototype.$video = Video;

import { vueBaberrage } from 'vue-baberrage'
Vue.use(vueBaberrage)


import VueConfetti from 'vue-confetti'
Vue.use(VueConfetti)
Vue.config.productionTip = false;

import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'

Vue.prototype.$swiper = Swiper
for (const key in config) {
    Vue.prototype[key] = config[key];
}
import * as filters from './utils/fdate.js';
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});
new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");